<template>
  <ContextMenu :id="id" :items="mobile ? mobileMenu : menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
import CancelEnrollmentModal from "./CancelEnrollmentModal";

export default {
  mixins: [ContextMenuMixin],

  props: {
    mobile: { type: Boolean, default: false },
    section: { type: String, default: "training" },
  },

  computed: {
    menu() {
      let menu = [];

      menu.push({
        label: "View User Details",
        action: () => {
          this.doAction("show-user-details");
        },
      });

      if (this.item.user_id == this.$root.user.id) {
        menu.push({
          label: "View Path Details",
          action: () => {
			  this.doAction("show-path-details");
//             this.goToRoute("training.learning-paths.enrollments.show", {
//               enrollment: this.item.id,
//             });
          },
        });
      } else {
        menu.push({
          label: "View Path Details",
          action: () => {
            this.doAction("show-path-details");
          },
        });
      }

      if (!!this.item.can_enroll) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.goToRoute("enroll.online.learning-path.self", {
              learning_path: this.item.learning_path_id,
            });
          },
        });
      }
      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.goToRoute("enroll.online.learning-path.others", {
              learning_path: this.item.learning_path_id,
            });
          },
        });
      }

      if (!!this.item.can_cancel && this.section == "admin") {
        menu.push({
          label: "Remove",
          action: () => {
            this.cancelEnrollment();
          },
        });
      }

      if (!!this.item.can_print_confirmation) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute(
              "enroll.online.print.learning-path-enrollment",
              {
                enrollment: this.item.id,
              },
              true
            );
          },
        });
      }

      if (!!this.item.can_print_certificate) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute(
              "training.learning-paths.enrollments.certificate",
              {
                enrollment: this.item.id,
              },
              true
            );
          },
        });
      }

      menu.sort(this.sortMenu);

      return menu;
    },

    mobileMenu() {
      let menu = [];

      menu.push({
        label: "View User Details",
        action: () => {
          this.goToRoute("training.users.show", { user: this.item.user_id });
        },
      });

      if (this.item.user_id == this.$root.user.id) {
        menu.push({
          label: "View Path Details",
          action: () => {
            this.goToRoute("training.learning-paths.enrollments.show", {
              enrollment: this.item.id,
            });
          },
        });
      } else {
        menu.push({
          label: "View Path Details",
          action: () => {
            this.goToRoute("learning-paths.show", {
              learning_path: this.item.learning_path_id,
            });
          },
        });
      }

      if (!!this.item.can_enroll) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.goToRoute("enroll.online.learning-path.self", {
              learning_path: this.item.learning_path_id,
            });
          },
        });
      }
      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.goToRoute("enroll.online.learning-path.others", {
              learning_path: this.item.learning_path_id,
            });
          },
        });
      }

      if (!!this.item.can_print_confirmation) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute(
              "enroll.online.print.learning-path-enrollment",
              {
                enrollment: this.item.id,
              },
              true
            );
          },
        });
      }

      if (!!this.item.can_print_certificate) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute(
              "training.learning-paths.enrollments.certificate",
              {
                enrollment: this.item.id,
              },
              true
            );
          },
        });
      }

      menu.sort(this.sortMenu);

      return menu;
    },
  },

  methods: {
    cancelEnrollment() {
      this.$modal(CancelEnrollmentModal, { enrollment: this.item })
        .then(() => {
          this.eventBus.$emit("refresh");
        })
        .catch(() => {});
    },
  },
};
</script>